// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParseEdcFileRequest
 */
export interface ParseEdcFileRequest {
    /**
     * 
     * @type {string}
     * @memberof ParseEdcFileRequest
     */
    upload_id: string;
}

/**
 * Check if a given object implements the ParseEdcFileRequest interface.
 */
export function instanceOfParseEdcFileRequest(value: object): value is ParseEdcFileRequest {
    if (!('upload_id' in value) || value['upload_id'] === undefined) return false;
    return true;
}

export function ParseEdcFileRequestFromJSON(json: any): ParseEdcFileRequest {
    return ParseEdcFileRequestFromJSONTyped(json, false);
}

export function ParseEdcFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParseEdcFileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'upload_id': json['upload_id'],
    };
}

export function ParseEdcFileRequestToJSON(json: any): ParseEdcFileRequest {
    return ParseEdcFileRequestToJSONTyped(json, false);
}

export function ParseEdcFileRequestToJSONTyped(value?: ParseEdcFileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'upload_id': value['upload_id'],
    };
}
